import { Popover } from "antd";
import React, { useEffect, useState } from "react";
const publishDateCont = (
    <div className="w-[450px] max-w-full p-[10px] text-[#2E2E2E] text-[13px]">
      <div className="text-center mb-[10px]"><strong>Publish Date</strong></div>
      <div>
        <p className="mb-[5px]"><strong>Publish Date for Banks & Financial Institutions</strong></p>
        <p className="mb-[15px]">A publishable period would be assigned by Ohhto, agents will only be able to set their publish date within the assigned publishable period.</p>
        <p className="mb-[8px]">
          eg. Publishable Period: 01 Jan 2020 – 31 Dec 2022 <br/>
          Agents will be able to set their Publish Date within this specified period.
        </p>
        <p className="mb-[8px] italic">*By Default, Ending Dates will be set as “Further Noticed” which has no definitive end date, Agents can contact Ohhto to change the Ending Date</p>
      </div>
      <div>
        <p>
          <strong>Publish Date In-House</strong>
        </p>
        <p>For In-house agent loan products, agents have to set their own publish dates for their own load products, there will not be a publishable period for In-hours products.</p>
      </div>
    </div>
)
const scheduleCont = (
  <div className="w-[400px] max-w-full p-[10px] text-[#2E2E2E] text-[13px]">
    <p className="text-center mb-[10px]"><strong>Schedule Changes</strong></p>
    <div>
      <p className="mb-[8px]">
      Agents can make changes to their rates and schedule a date & time for it to take effect, this is to ensure any changes to the Loan Products rates can be implemented in advance.
      </p>
      <p className="mb-[8px]">
      To set a Scheduled change, at date and time will need to be inputted. Scheduling is entirely optional, and can be skipped by leaving the  “Schedule for” section empty when editing the rates. 
      </p>
      <p className="mb-[8px] italic">
      *Scheduled changes can still be edited & changed as long as the as long as it has not passed the scheduled time set by previously
      </p>
    </div>
  </div>
)
const CustomPopOver = (props) => {
  const {For} = props;
  const [popContent,setPopContent] = useState();
  useEffect(()=>{
    switch(For){
      case 'publish':
        setPopContent(publishDateCont);
        break;
      case 'schedule':
        setPopContent(scheduleCont);
        break;
      default:
        break;
    }
  },[])
  return (
    <Popover content={popContent} arrow={false} placement="topLeft">
        <img src="/images/fi_info.svg" alt="info" className="inline-block ml-[8px]"/>
    </Popover>
  )
};

export default CustomPopOver;
